<template>
<main>
    <breadcrumbs></breadcrumbs>
    <div class="content-wrapper">
      <div class="content-width">
        <p>
          Rojeca advies heeft voor eigen rijders een scherpe prijs omtrent het jaarcontract. Hiervoor krijgt u een audit op het bedrijf, zeven dagen in de week advies en wordt u op de hoogte gehouden van alle nieuwe ontwikkelingen binnen het ADR. Voor eigen rijders kunt u in het weekend rekenen op een audit.
        </p>
        <p>
          Bedrijven met logistiek of opslag krijgen hier een offerte op maat. Voor elke audit reis ik 75 km zonder meerprijs. Daarboven reken ik een toeslag van € 0,40 per km. Alle bedragen zijn exclusief BTW.
        </p>        
        <router-link to="/contact"><button>Kom in contact</button></router-link>
      </div>

    </div>
</main>
</template>

<script>

import Breadcrumbs from './breadcrumbs'

export default {
  name: 'ContentTakenpakket',
  components: {
      Breadcrumbs
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/content-diensten.vue